import { Component, Input } from '@angular/core';
import { CustomFieldValue } from 'src/app/shared/models/custom-field-value';

@Component({
    selector: 'nova-custom-field-grid-cell',
    templateUrl: './custom-field-grid-cell.component.html',
    styleUrls: ['./custom-field-grid-cell.component.scss']
})
export class CustomFieldGridCellComponent {
    @Input()
    customFields: CustomFieldValue[] = [];

    constructor() {}
}
